import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, MapPin, Sparkles } from "lucide-react";
import { WHATSAPP_LINK, INSTAGRAM_URL, WHATSAPP_NUMBER } from "../lib/api";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-white relative overflow-hidden border-t-4 border-yolk">
      <div className="absolute inset-0 confetti opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size="default" onDark={true} />
            <p className="mt-6 text-white/70 max-w-sm leading-relaxed">
              Imprenta artesanal en Copiapó. Figuras 3D coleccionables, papelería personalizada
              y mucho cariño en cada pedido.
            </p>
            <div className="mt-5 flex items-center gap-2 text-yolk text-sm">
              <Sparkles className="h-4 w-4" />
              <span className="font-accent italic">Hecho con cariño en Copiapó</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.25em] text-yolk mb-5 font-bold">Navegación</h4>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/" className="hover:text-mint transition">Inicio</Link></li>
              <li><Link to="/papeleria" className="hover:text-mint transition">Papelería</Link></li>
              <li><Link to="/3d" className="hover:text-mint transition">Figuras 3D</Link></li>
              <li><Link to="/cotizar" className="hover:text-mint transition">Cotizar</Link></li>
              <li><Link to="/contacto" className="hover:text-mint transition">Contacto</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.25em] text-yolk mb-5 font-bold">Contacto</h4>
            <ul className="space-y-4 text-white/70">
              <li>
                <a href={WHATSAPP_LINK()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 hover:text-mint transition">
                  <MessageCircle className="h-4 w-4 text-mint shrink-0" />
                  WhatsApp {WHATSAPP_NUMBER}
                </a>
              </li>
              <li>
                <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-3 hover:text-yolk transition">
                  <Instagram className="h-4 w-4 text-yolk shrink-0" />
                  @a.l.a_grafica_spa_copiapo
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-white/50 shrink-0" />
                Copiapó, Chile
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} A.L.A Grafics SpA · Todos los derechos reservados.
          </p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-white/40 hover:text-yolk transition">
            Acceso Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
